import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../config/api';
import { applyAppLanguage, getPendingAppLanguage } from '../utils/appLanguage';

/**
 * Load the stored language once on startup. Later picks from the nav
 * selector must not be overwritten by a stale preferences fetch.
 */
const LanguageLoader = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    let cancelled = false;

    const loadUserLanguage = async () => {
      try {
        const token = localStorage.getItem('token');
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (!token) {
          if (savedLanguage && !cancelled) {
            await applyAppLanguage(savedLanguage, i18n);
          }
          return;
        }

        const response = await api.get('/preferences');
        if (cancelled) return;
        const pending = getPendingAppLanguage() || localStorage.getItem('preferredLanguage');
        const preferredLanguage = pending
          || response.data.preferredLanguage
          || savedLanguage
          || 'en';
        await applyAppLanguage(preferredLanguage, i18n);
      } catch (error) {
        console.error('Failed to load user language preference:', error);
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (savedLanguage && !cancelled) {
          await applyAppLanguage(savedLanguage, i18n);
        }
      }
    };

    loadUserLanguage();
    return () => {
      cancelled = true;
    };
    // Load once on startup. Re-running on i18n updates would overwrite a
    // language the user just picked with the previous saved preference.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default LanguageLoader;
